module.exports = __webpack_public_path__ + "img/cons.f557a42a.png";